import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

interface AddEditObjectType {
  UserReviewID: number;
  Title: string;
  Comments: string;
  Rating: number;
  IsPublished: boolean;
  IsAbused: boolean;
  ObjectID: number;
  IsFeatured: boolean;
  Distance: number;
  ServiceID: number;
  VanType: number;
  NumberOfMoverID: number;
  ReferencePID: number;
  refrence: string;
  CreationTimestamp: Date;
}

function UserReview() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    UserReviewID: 0,
    SiteUserID: 0,
    Title: "",
    Comments: "",
    Rating: 0,
    IsPublished: false,
    IsAbused: false,
    ObjectID: 0,
    IsFeatured: false,
    Distance: 0,
    ServiceID: 0,
    VanType: 0,
    NumberOfMoverID: 0,
    ReferencePID: 0,
    refrence: 0,
    CreationTimestamp: new Date(),
  });
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenFilterListData, setScreenFilterListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenFilterListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/UserReview/UserReviewGetCompleteDataSetForForeignKeys",
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          setScreenFilterListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenFilterListData() {
    setIsAnimation(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.APIURL + "api/UserReview/GetReferencePageFiltersListsData",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          var l_arrTypes = [
            { PID: 1, Name: "Driver" },
            { PID: 2, Name: "Helper" },
          ];
          l_oResponse.push(l_arrTypes);

          var l_arrTiers = [
            { PID: 1, Name: "1" },
            { PID: 2, Name: "2" },
            { PID: 3, Name: "3" },
          ];
          l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(AppContext.APIURL + "api/UserReview/UserReviewGetCompleteGridData")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false,
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "UserReviewID",
              selectedMoverID,
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    // if (!addEditObject.SiteUserID || addEditObject.SiteUserID == 0) {
    //   showErrorMessage("Please select User");
    //   IsOkay = false;
    // } else
    if (!addEditObject.Title || addEditObject.Title == "") {
      showErrorMessage("Please enter Title");
      IsOkay = false;
    } else if (!addEditObject.Comments || addEditObject.Comments == "") {
      showErrorMessage("Please enter comment");
      IsOkay = false;

      if (addEditObject.Distance < 0) {
        showErrorMessage("Distance cannot be negative");
        IsOkay = false;
        return;
      }
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function DataRefrenceDetailsForJob() {
    setIsAnimation(true);
    let object = {} as any;
    object.Refrence = addEditObject.refrence;

    if (!object.Refrence || object.Refrence.trim() === "") {
      showErrorMessage("Please enter job id.");
      setIsAnimation(false);
      return;
    }

    axiosAuth
      .post(
        AppContext.APIURL + "api/UserReview/GetDataRefrenceDetailsForJob",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          const decryptedData = response.data.Data;
          const jobDetails = decryptedData[0];

          setAddEditObject((prevState: AddEditObjectType) => ({
            ...prevState,
            ObjectID: jobDetails.LocationID,
            Distance: jobDetails.Distance,
            ServiceID: jobDetails.ServiceID,
            VanType: jobDetails.VanType,
            NumberOfMoverID: jobDetails.NumberOfMoverID,
            ReferencePID: jobDetails.ReferencePID,
          }));
        } else {
          showErrorMessage(
            response.data.Message || "Failed to load job details",
          );
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.userreviewid = addEditObject.UserReviewID;
    object.serviceid = addEditObject.ServiceID;
    object.vantype = addEditObject.VanType;
    object.numberofmoverid = addEditObject.NumberOfMoverID;

    object.servicename = getNameByID(1, addEditObject.ServiceID);
    object.vantypename = getNameByID(2, addEditObject.VanType);
    object.numberofmovertext = getNameByID(3, addEditObject.NumberOfMoverID);

    // object.SiteUserID = addEditObject.SiteUserID;
    object.title = addEditObject.Title;
    object.comment = addEditObject.Comments;
    object.rating = addEditObject.Rating;
    object.ispublished = addEditObject.IsPublished;
    object.isabused = addEditObject.IsAbused;
    object.objectid = addEditObject.ObjectID;
    object.isfeatured = addEditObject.IsFeatured;
    object.distance = addEditObject.Distance;
    object.refrence = addEditObject.refrence;
    object.creationtimestamp = addEditObject.CreationTimestamp;

    axiosAuth
      .post(AppContext.APIURL + "api/UserReview/UserReviewSaveCustom", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getNameByID(type: any, id: any) {
    let name = "";
    // screenListData[1] --  service -- type:1
    // screenListData[2] -- vantype -- type:2
    // screenListData[3] -- movers -- type:3

    if (id && id != "" && id > 0) {
      if (type == 1) {
        for (let index = 0; index < screenListData[1].length; index++) {
          if (screenListData[1][index].PID == id) {
            name = screenListData[1][index].Name;
            break;
          }
        }
      } else if (type == 2) {
        for (let index = 0; index < screenListData[2].length; index++) {
          if (screenListData[2][index].PID == id) {
            name = screenListData[2][index].Name;
            break;
          }
        }
      } else if (type == 3) {
        for (let index = 0; index < screenListData[3].length; index++) {
          if (screenListData[3][index].PID == id) {
            name = screenListData[3][index].Name;
            break;
          }
        }
      }
    }

    return name;
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.UserReviewID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/UserReview/UserReviewDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "SiteUserName")) {
        (
          document.getElementById(
            "imgSort" + "SiteUserName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Title")) {
        (
          document.getElementById("imgSort" + "Title") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Comments")) {
        (
          document.getElementById("imgSort" + "Comments") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      UserReviewID: 0,
                      SiteUserID: 0,
                      Title: "",
                      Comments: "",
                      Rating: 0,
                      IsPublished: false,
                      IsAbused: false,
                      ObjectID: 0,
                      IsFeatured: false,
                      Distance: 0,
                      ServiceID: 0,
                      VanType: 0,
                      NumberOfMoverID: 0,
                      ReferencePID: 0,
                      refrence: "",
                      CreationTimestamp: new Date(),
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tbluserReview", "UserReview")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tbluserReview">
              <thead>
                <tr>
                  {/* <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        User
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "SiteUserName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("SiteUserName")}
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "SiteUserName"}></span>
                        </a>
                      </div>
                    </div>
                  </th> */}
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Title
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Title")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Title")}
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "Title"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdmd">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Comments
                        {/* <a
                          onClick={(e) => ShowColumnFilterList(e, "Comments")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a> */}
                        <a
                          onClick={() => LoadWithSelectedSort("Comments")}
                          title={"Sort By User"}
                        >
                          <span id={"imgSort" + "Comments"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Rating</th>
                  <th>Is Published</th>
                  <th>Is Abused</th>
                  <th>Location</th>
                  <th>Is Featured</th>
                  <th>Distance</th>
                  <th className="reuse-tdsm2">Service</th>
                  <th>Van Type</th>
                  <th>Number Of Mover</th>
                  <th>Refrence</th>
                  <th>Creation Date</th>
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr className={item.ReferencePID === 0 ? "c-red" : ""}>
                          {/* <td>{item.SiteUserName}</td> */}
                          <td>{item.Title}</td>
                          <td>
                            {/* {item.Comments} */}
                            <textarea
                              disabled
                              style={{
                                minHeight: "10px",
                                minWidth: "150px",
                                maxHeight: "180px",
                                overflow: "auto",
                                display: "inline-block",
                                lineHeight: "20px",
                                resize: "none",
                              }}
                              value={item.Comments}
                            ></textarea>
                          </td>
                          <td>{item.Rating}</td>
                          <td>{item.IsPublished == true ? "True" : "False"}</td>
                          <td>{item.IsAbused == true ? "True" : "False"}</td>
                          <td>{item.ObjectName}</td>
                          <td>{item.IsFeatured == true ? "True" : "False"}</td>
                          <td>{item.Distance}</td>
                          <td>{item.ServiceName}</td>
                          <td>{item.VanTypeName}</td>
                          <td>{item.NumberOfMover}</td>
                          <td>{item.Refrence}</td>
                          <td>{formateDate(item.CreationTimestamp)}</td>
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject({
                                    UserReviewID: item.UserReviewID,
                                    SiteUserID: item.SiteUserID,
                                    Title: item.Title,
                                    Comments: item.Comments,
                                    Rating: item.Rating,
                                    IsPublished: item.IsPublished,
                                    IsAbused: item.IsAbused,
                                    ObjectID: item.ObjectID,
                                    // ObjectName: item.ObjectName,
                                    IsFeatured: item.IsFeatured,
                                    Distance: item.Distance,
                                    ServiceID: item.ServiceID,
                                    VanType: item.VanType,
                                    NumberOfMoverID: item.NumberOfMoverID,
                                    ReferencePID: item.ReferencePID,
                                    refrence: item.Refrence,
                                    CreationTimestamp: item.CreationTimestamp,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.UserReviewID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20 flex-as">
              {/* <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">User:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.SiteUserID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SiteUserID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select User</option>
                  {screenFilterListData[0] &&
                    screenFilterListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div> */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Title:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Title}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Title: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Comments:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.Comments}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Comments: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Rating:</span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.Rating}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Rating: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Job ID:</span>
                <input
                  className="input-field w-100"
                  type="text"
                  value={addEditObject.refrence}
                  onChange={(e) =>
                    setAddEditObject((p: any) => ({
                      ...p,
                      refrence: e.target.value,
                    }))
                  }
                />
                <div className="btn-start flex-daj">
                  <a
                    className="btn-primary flex-daj w-100 relative-btn"
                    onClick={() => DataRefrenceDetailsForJob()}
                  >
                    Get Detail
                  </a>
                </div>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Location:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.ObjectID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Location</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Distance:</span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.Distance}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Distance: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Service:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.ServiceID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ServiceID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Service</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Van Type:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.VanType}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      VanType: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Van Type</option>
                  {screenListData[2] &&
                    screenListData[2].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Number Of Mover:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.NumberOfMoverID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      NumberOfMoverID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Mover</option>
                  {screenListData[3] &&
                    screenListData[3].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Creation Time stamp:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={moment(addEditObject.CreationTimestamp).format(
                    "YYYY-MM-DD",
                  )}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      CreationTimestamp: moment(e.target.value).format(
                        "YYYY-MM-DD",
                      ),
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Published:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsPublished}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsPublished: e.target.checked ? true : false,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Abused:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsAbused}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsAbused: e.target.checked,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Featured:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsFeatured}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsFeatured: e.target.checked,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default UserReview;
